import React, { useEffect } from "react";
import { OrganizationContent } from "../components";
import {
	OrganizationWrapper,
	OrganizationNameGeneralBox,
	OrganizationApiGeneralBox,
	OrganizationInput,
	OrganizationSubscribeBox,
	AppListWrapper,
	DescriptionUpperTitleImage,
	AppTitleWrapper,
	AppPaymentChangeButton,
	AppTitleNameWrapper,
	AppTitleName,
	AppDetailWrapper,
	AppDetailTitle,
	AppDetailContents,
	WebcomePlanGuideWrapper,
} from "./style";

import SecretBox from "@/components/SecretBox";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyDetailInfo, getCompanyInfo } from "@/redux/organization/selector";
import { Skeleton } from "@mui/lab";
import { format } from "date-fns";
import { ko, enUS } from "date-fns/locale";
import { useFormik } from "formik";
import API from "@/api/serverCall";
import { CompanyResponseDto } from "@/api/interface";
import axios from "axios";
import { useSnackbar } from "notistack";
import { setCompanyInfo } from "@/redux/organization/actions";
import { getUserInfo } from "@/redux/user/selector";
import application_icon from "@/assets/application_icon.svg";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface initialValues {
	companyName: string;
}

interface PatchCompanyRequestParam {
	email: "";
	phone: "";
	name: string;
}

export default function OrganizationGeneral() {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();
	const history = useHistory();
	const { enqueueSnackbar } = useSnackbar();
	// const companyInfo = useSelector(getCompanyInfo);
	const companyDetailInfo = useSelector(getCompanyDetailInfo)?.body;
	/* if (!companyDetailInfo) {
		return <Loader />;
	} */
	const userInfo = useSelector(getUserInfo);

	const initialValues: initialValues = {
		companyName: "",
	};

	const { values, setFieldValue, getFieldProps } = useFormik<initialValues>({
		initialValues,
		onSubmit: () => {
			//
		},
	});

	const handleClickSaveCompanyName = async () => {
		try {
			if (!values.companyName || !userInfo?.isOwner) {
				return;
			}

			const body: PatchCompanyRequestParam = {
				email: "",
				phone: "",
				name: values.companyName,
			};

			const { data } = await API.patch<CompanyResponseDto>({
				link: "/company",
				body,
			});

			enqueueSnackbar("저장했습니다", {
				variant: "success",
			});

			dispatch(setCompanyInfo(data));
		} catch (e) {
			if (axios.isAxiosError(e)) {
				enqueueSnackbar("저장 실패", {
					variant: "error",
				});
			}
		}
	};

	useEffect(() => {
		if (!companyDetailInfo) {
			return;
		}

		setFieldValue("companyName", companyDetailInfo.name);
	}, [companyDetailInfo]);

	return (
		<OrganizationContent title={t("organization_general.title")}>
			{/* <OrganizationSubscribeBox /> */}
			{companyDetailInfo &&
				companyDetailInfo.apps.length > 0 &&
				(companyDetailInfo?.apps[0].planType === "welcome" ||
					companyDetailInfo?.apps[0].planType == null) && (
					<WebcomePlanGuideWrapper>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
						>
							<g clipPath="url(#clip0_103_1294)">
								<path
									d="M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM12 17.3C11.28 17.3 10.7 16.72 10.7 16C10.7 15.28 11.28 14.7 12 14.7C12.72 14.7 13.3 15.28 13.3 16C13.3 16.72 12.72 17.3 12 17.3ZM13 13H11V7H13V13Z"
									fill="#E14400"
								/>
							</g>
							<defs>
								<clipPath id="clip0_103_1294">
									<rect width="24" height="24" fill="white" />
								</clipPath>
							</defs>
						</svg>
						<span style={{ whiteSpace: "pre-wrap" }}>
							{t("organization_general.alarm")}
						</span>
					</WebcomePlanGuideWrapper>
				)}
			<OrganizationWrapper>
				<OrganizationNameGeneralBox title={t("organization_general.name")}>
					{companyDetailInfo && (
						<OrganizationInput
							placeholder="변경할 조직이름을 입력해주세요"
							{...getFieldProps("companyName")}
							onClickSubmit={handleClickSaveCompanyName}
							onClickCancel={() =>
								setFieldValue("companyName", companyDetailInfo.name)
							}
							readOnly={!userInfo?.isOwner}
							showExtraButton={Boolean(
								values.companyName &&
									values.companyName !== companyDetailInfo.name,
							)}
						/>
					)}
				</OrganizationNameGeneralBox>
				<OrganizationApiGeneralBox title={t("organization_general.token")}>
					{companyDetailInfo?.companyToken && companyDetailInfo?.createdAt ? (
						<SecretBox
							label="ID"
							value={companyDetailInfo?.companyToken || ""}
							/* tooltip={`${format(
								new Date(companyDetailInfo?.createdAt),
								"yyyy년 MM월 dd일 a hh:mm",
								{
									locale: ko,
								},
							)}에 마지막으로 생성됨`} */
							tooltip={
								i18n.language === "ko"
									? `${format(
											new Date(companyDetailInfo?.createdAt),
											"yyyy년 MM월 dd일 a hh:mm",
											{
												locale: ko,
											},
									  )}에 마지막으로 생성됨`
									: `Last generated on ${new Date(
											companyDetailInfo?.createdAt,
									  ).toLocaleDateString("en-US", {
											year: "numeric",
											month: "long",
											day: "numeric",
											hour: "numeric",
											minute: "numeric",
									  })}`
							}
						/>
					) : (
						<Skeleton height={40} />
					)}
				</OrganizationApiGeneralBox>
			</OrganizationWrapper>
			{companyDetailInfo?.apps.map((app, index) => {
				return (
					<AppListWrapper>
						<AppTitleWrapper>
							<AppTitleNameWrapper>
								<DescriptionUpperTitleImage>
									<img
										src={application_icon}
										alt="사진없음"
										style={{ width: "90%" }}
									/>
								</DescriptionUpperTitleImage>
								<AppTitleName>{app.name}</AppTitleName>
							</AppTitleNameWrapper>
							<AppPaymentChangeButton
								variant="outlined"
								onClick={() =>
									history.push(`/price`, {
										appId: app.id,
										appName: app.name,
										isUse: app.isUse,
									})
								}
							>
								{t("organization_general.change_payment")}
							</AppPaymentChangeButton>
						</AppTitleWrapper>
						<AppDetailWrapper>
							<AppDetailContents>
								<AppDetailTitle width="8rem">
									{t("organization_general.subscription_plan")}
								</AppDetailTitle>
								<div style={{ fontWeight: 700 }}>{app.planName}</div>
							</AppDetailContents>
							<AppDetailContents>
								<AppDetailTitle width="10rem">
									{t("organization_general.used_api")}
								</AppDetailTitle>
								<div style={{ fontWeight: 700 }}>
									{app.isFoodLens ? "FoodLens" : "CaloAI"}
								</div>
							</AppDetailContents>
							<AppDetailContents>
								<AppDetailTitle width="8rem">
									{t("organization_general.creation_date")}
								</AppDetailTitle>
								<div>
									{i18n.language === "ko" && (
										<>
											{format(
												new Date(app.createdAt),
												"yyyy년 MM월 dd일",
												{
													locale: ko,
												},
											)}
										</>
									)}
									{i18n.language === "en" && (
										<>
											{new Date(app.createdAt).toLocaleString(
												"en-US",
												{
													month: "long",
													year: "numeric",
													day: "numeric",
												},
											)}
										</>
									)}
								</div>
							</AppDetailContents>
							<AppDetailContents>
								<AppDetailTitle width="10rem">
									{t("organization_general.android_package_name")}
								</AppDetailTitle>
								<div>
									{app.packageAndroid === "" ? "-" : app.packageAndroid}
								</div>
							</AppDetailContents>
							<AppDetailContents>
								<AppDetailTitle width="8rem">
									{t("organization_general.renewal_date")}
								</AppDetailTitle>
								<div>-</div>
							</AppDetailContents>
							<AppDetailContents>
								<AppDetailTitle width="10rem">
									{t("organization_general.ios_package_name")}
								</AppDetailTitle>
								<div>{app.packageIos === "" ? "-" : app.packageIos}</div>
							</AppDetailContents>
							<AppDetailContents>
								<AppDetailTitle width="8rem">
									{t("organization_general.app_token")}
								</AppDetailTitle>
								<div>
									<SecretBox
										value={app.appToken === "" ? "-" : app.appToken}
										width="330px"
									/>
								</div>
							</AppDetailContents>
						</AppDetailWrapper>
					</AppListWrapper>
				);
			})}
		</OrganizationContent>
	);
}
